export var normalPage = {
    width: "1200px",
};
export var narrowPage = {
    width: "800px"
};
//# sourceMappingURL=dataTypes.js.map